import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import HotRecommendations from './components/HotRecommendations';
import FeaturedColumns from './components/FeaturedColumns';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { homeContent } from '@/mocks/home';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '亚洲专区',
      url: window.location.origin,
      description: '汇聚亚洲各地精选优质内容，涵盖文化、娱乐、资讯、产品与服务。一站式探索亚洲无限可能。',
      sameAs: [],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebSite',
      name: '亚洲专区',
      url: window.location.origin,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${window.location.origin}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: homeContent.faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection
          title={homeContent.hero.title}
          subtitle={homeContent.hero.subtitle}
          description={homeContent.hero.description}
        />
        <CategoryNav />
        <FeaturedArticles />
        <HotRecommendations />
        <FeaturedColumns columns={homeContent.columns} />
        <FAQSection faqs={homeContent.faqs} />
        <NewsletterSection
          testimonials={homeContent.testimonials}
          stats={{ stats: homeContent.stats }}
        />
      </main>
      <Footer />
    </>
  );
}